import { doGet } from "../base";

const SUPPORT_DOCS_URL = "/user_auth/support/docs";

export const fetchDocuments = async () => {

    var url = SUPPORT_DOCS_URL;

    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};
